module.exports = __webpack_public_path__ + "img/teaser-logo.463e5883.webp";